import React from 'react'
import PropTypes from 'prop-types'

class Rect extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    data: PropTypes.object
  }

  render() {
    const {index, x0, x1, y0, y1} = this.props.data
    const {dimensions, conversion, conversionPercent, touchpoints} = this.props.data
    return (
      <>
        <rect
          x={x0}
          y={y0}
          rx='5'
          width={x1 - x0}
          height={y1 - y0}
          fill='#aeb6be'
          data-index={index}
        />
        <rect
          x={x0}
          y={y1 + 5}
          rx='3'
          width={x1 - x0}
          height={55}
          fill='#fff'
          stroke='#eff3f6'
          strokeWidth={2}
          data-index={index}
        />
        <g className='sankey-chart_rect_label'>
          <text
            x={x0 + 10}
            y={y1 + 30}
            style={{
              fill: '#b0afb7',
              fontSize: 14,
              fontWeight: 600
            }}
          >
            <tspan>{dimensions.channelGroup}</tspan>
            <tspan x={x0 + 190} textAnchor='end'>
              Conversions
            </tspan>
            <tspan x={x0 + 300} textAnchor='end' >% Conversions</tspan>
            <tspan x={x0 + 400} textAnchor='end' >Touchpoints</tspan>
          </text>
        </g><g className='sankey-chart_rect_value'>
          <text
            x={x0 + 10}
            y={y1 + 50}
            style={{
              fill: '#1f1f1f',
              fontSize: 15,
              fontWeight: 600
            }}
          >
            <tspan>{dimensions.channel}</tspan>
            <tspan x={x0 + 190} textAnchor='end'>
              {conversion}
            </tspan>
            <tspan x={x0 + 300} textAnchor='end' >{conversionPercent}</tspan>
            <tspan x={x0 + 400} textAnchor='end' >{touchpoints}</tspan>
          </text>
        </g>
      </>
    )
  }
}
export default Rect



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrChart/SankeyChart/Rect.js